import { isValidUrl } from "@elixir/utils";
import { RadioButton, InputField } from "ui";
import useTeleConfigurationStore from "../../../../../stores/vc-meta-store";
import { useState } from "react";
import { SupportedTeleProviders } from "@elixir/types";

function HundredMsTelePlatform() {
  const platform = useTeleConfigurationStore((state) => state.platform);
  const meetLink = useTeleConfigurationStore((state) => state.meetLink);
  const hostLink = useTeleConfigurationStore((state) => state.hostLink);

  const setPlatform = useTeleConfigurationStore((state) => state.setPlatform);
  const setMeetLink = useTeleConfigurationStore((state) => state.setMeetLink);
  const setHostLink = useTeleConfigurationStore((state) => state.setHostLink);

  const [errorState, setErrorState] = useState({
    guestUrlError: "",
    hostUrlError: "",
  });

  return (
    <>
      <RadioButton
        isSelected={platform === SupportedTeleProviders["100MS"]}
        label="100Ms"
        onClick={() => {
          if (platform === SupportedTeleProviders["100MS"]) {
            return;
          }

          setPlatform(SupportedTeleProviders["100MS"]);
        }}
      />
      {platform === SupportedTeleProviders["100MS"] ? (
        <div className="dr-px-14">
          <InputField
            name="100ms-guest-url"
            prefixText="Guest URL"
            helperText="Include the meeting URL to be sent to the patient"
            className="dr-py-12"
            placeholder="Enter Guest Meeting URL"
            onChange={(e) => {
              const val = e.target.value;
              setMeetLink(val);
              setErrorState((state) => ({
                ...state,
                guestUrlError: "",
              }));
            }}
            value={meetLink}
            isMandatory
            error={errorState.guestUrlError}
            onBlur={({ value }) => {
              if (!isValidUrl(value)) {
                setErrorState((state) => ({
                  ...state,
                  guestUrlError: "Invalid Guest URL",
                }));
              }
            }}
          />
          <InputField
            name="100ms-host-url"
            isMandatory
            prefixText="Host URL"
            helperText="Include the meeting URL to be accessed by the doctor/staff"
            className="dr-py-12"
            placeholder="Enter Host Meeting URL"
            value={hostLink}
            onChange={(e) => {
              const val = e.target.value;
              setHostLink(val);
              setErrorState((state) => ({
                ...state,
                hostUrlError: "",
              }));
            }}
            error={errorState.hostUrlError}
            onBlur={({ value }) => {
              if (!isValidUrl(value)) {
                setErrorState((state) => ({
                  ...state,
                  hostUrlError: "Invalid Host URL",
                }));
              }
            }}
          />
        </div>
      ) : null}
    </>
  );
}

export default HundredMsTelePlatform;
